import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  getReceptoresDePagos,
  postReceptorDePagos,
  patchReceptorDePago,
  deleteReceptorDePago,
} from 'api/catalogos/receptoresDePagos';

export const permissionConfig = {
  permissionModel: 'receptoresdepagos',
};

// eslint-disable-next-line react/prop-types
const ReceptoresDePagos = ({ permission }) => (
  <PlainCRUD
    title="Receptor de Banco"
    permission={permission}
    get={getReceptoresDePagos}
    post={postReceptorDePagos}
    patch={patchReceptorDePago}
    delete={deleteReceptorDePago}
    fields={[
      defaultFields.descripcion,
      {
        name: 'tipo_de_comercio_descripcion',
        label: 'Tipo de Comercio',
        colWidth: 200,
      },
      {
        name: 'tipo_de_documento_descripcion',
        label: 'Tipo de Documento',
        colWidth: 200,
      },
    ]}
  />
);

export default ReceptoresDePagos;
